import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { PICFLOW_CONFIG } from '../picflow-config';

export interface DomainInfo {
  domainInfo: {
    input: string;
    tld: string;
    sld: string;
    domain: string;
    subdomain: string;
    listed: true;
  };
  isEmailProvider: boolean;
  isBurner: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DomainInfoService {
  private http = inject(HttpClient);
  private config = inject(PICFLOW_CONFIG);

  getDomainInfo(domain: string): Observable<DomainInfo> {
    if (this.config.env === 'local')
      return of(<DomainInfo>{
        domainInfo: {
          subdomain: 'clerk-satallite',
        },
      });
    return this.http.get<DomainInfo>(`/domain-info/${domain}`).pipe(
      catchError(err => {
        console.error(err);
        return of(<DomainInfo>{
          domainInfo: {},
        });
      })
    );
  }
}
